import { useDispatch, useSelector } from 'react-redux';
import { useKeyboard } from '../../../shared/hooks/useKeyboard';
import { useWindowListener } from '../../../shared/hooks/useWindowListener';
import { unsetCreateMode } from '../../wave/thunks/unset-create-mode.thunk';
import { CreateMode } from '../../wave/utils/create.utils';
import { setCreateMode } from '../../wave/thunks/set-create-mode.thunk';
import { WaveAnnotateSelector } from '../../waves-tags-display-annotate/selectors/wave-tag-display-annotate.selectors';

export const useQRSListener = () => {
  const dispatch = useDispatch();
  const allowQrsAnnotations = useSelector(WaveAnnotateSelector('QRS'));
  const allowPAnnotations = useSelector(WaveAnnotateSelector('P'));
  const allowTAnnotations = useSelector(WaveAnnotateSelector('T'));

  /*
   * Create listeners
   */
  useKeyboard('keydown', 'p', () => {
    if (allowPAnnotations) {
      dispatch(setCreateMode(CreateMode.P));
    }
  });

  useKeyboard('keydown', 'q', () => {
    if (allowQrsAnnotations) {
      dispatch(setCreateMode(CreateMode.QRS));
    }
  });

  useKeyboard('keydown', 'r', () => {
    if (allowQrsAnnotations && allowTAnnotations) {
      dispatch(setCreateMode(CreateMode.QRST));
    }
  });

  useKeyboard('keydown', 't', () => {
    if (allowTAnnotations) {
      dispatch(setCreateMode(CreateMode.T));
    }
  });

  useKeyboard('keydown', 'x', () => {
    dispatch(setCreateMode(CreateMode.X));
  });

  useWindowListener('keyup', () => {
    dispatch(unsetCreateMode());
  });
};
